// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"f7a90e99","453":"2ca86739","821":"18b52154"}[chunkId] + ".chunk.js";
};